export type SearchMode = 'contains' | 'exact' | 'beginsWith';

export interface GridMetadata {
  count?: number;
  matchedCount?: number;
  limit?: number;
  page?: number;
  pageCount?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export const DEFAULT_GRID_LIMIT = 25;
export const GRID_LIMIT_OPTIONS = [25, 50, 100];
export const CMMC_LEVEL_OPTIONS = ['', 'L1', 'L2', 'L3'];

export function metadataFromResponse(response: GridMetadata): GridMetadata {
  return {
    count: response.count,
    matchedCount: response.matchedCount,
    limit: response.limit,
    page: response.page,
    pageCount: response.pageCount,
    hasPreviousPage: response.hasPreviousPage,
    hasNextPage: response.hasNextPage,
  };
}
